const IngreditentPointMap = {
  pattyUnCooked: 4,
  pattyCooked: 8,
  pattyOverCooked: 4,
  lettuce: 6,
  cheese: 4,
  buntop: 0,
  bunbottom: 0,
};

const burgerType = {
  b1: { ingredients: ["bunbottom", "patty", "buntop"], points: 8, time: 45 },
  b2: {
    ingredients: ["bunbottom", "patty", "lettuce", "buntop"],
    points: 14,
    time: 45,
  },
  b3: {
    ingredients: ["bunbottom", "patty", "lettuce", "cheese", "buntop"],
    points: 18,
    time: 45,
  },
  b4: {
    ingredients: ["bunbottom", "patty", "lettuce", "cheese", "patty", "buntop"],
    points: 26,
    time: 45,
  },
};
export { IngreditentPointMap, burgerType };
